export default "__VITE_ASSET__FuRNqU9G__"